import { FC, useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mantine/core'
import { PlayCircle } from 'lucide-react'

interface ModalProps {
  dialogProps: AlertDialogProps
  videoUrl?: string | null
  onCloseModal?: () => void
}

export const ShowVideoModal: FC<ModalProps> = props => {
  const { dialogProps, videoUrl } = props
  const [isVideoLoaded, setIsVideoLoaded] = useState(false)
  const { t } = useTranslation(['common'])

  useEffect(() => {
    if (dialogProps.open) {
      setIsVideoLoaded(false)
    }
  }, [dialogProps.open])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className='overflow-y-auto max-h-[95vh] max-w-[1000px] w-full'>
        <DialogHeader>
          <DialogTitle className='mb-4'>{t('webinar.sing')}</DialogTitle>
          {videoUrl && (
            <div className='w-full aspect-[16/9] relative'>
              {!isVideoLoaded && (
                <div className='absolute inset-0 z-10'>
                  <Skeleton className='w-full h-full' />
                  <div className='absolute inset-0 flex items-center justify-center text-white opacity-70'>
                    <PlayCircle size={100} />
                  </div>
                </div>
              )}

              <iframe
                src={videoUrl}
                allowFullScreen
                className='w-full h-full rounded'
                onLoad={() => {
                  setIsVideoLoaded(true)
                }}
              />
            </div>
          )}
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
